import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import MySettingCard from './MySettingCard';
import {
  TimeActivityIcon,
  AmountsOwedIcon,
  DailyTotalsIcon,
  ActivitynIcon,
  TimesheetIcon,
  InsightsnIcon,
  InvoicesIcon,
  CalendarbIcon,
  TimeOffIcon,
  MapIcon,
  JobSitesIcon,
  PaymentsnIcon,
  AchievementsIcon,
  WorkBreaksnIcon,
  OvertimeIcon,
} from '../../../icons'; // Adjust if your path differs
import { enableDisableFeaturesData } from './EnableDisableFeaturesData';

const EnableDisableFeatures = () => {
  const [loading, setLoading] = useState(true);
  const [cardStates, setCardStates] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCardStates(enableDisableFeaturesData);
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  const handleToggleClick = (card) => {
    setSelectedCard(card);
    setOpenModal(true);
  };

  const handleConfirmToggle = () => {
    setCardStates((prev) =>
      prev.map((card) =>
        card.title === selectedCard.title
          ? { ...card, status: card.status === 'enabled' ? 'disabled' : 'enabled' }
          : card
      )
    );
    setOpenModal(false);
  };

  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight={600} mb={3} color="#333">
        Enable or Disable Features
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        mb={4}
        sx={{ maxWidth: 600 }}
      >
        Personalize your organization's activated features by disabling features you don't need.
        Any changes made will impact your entire organization interface and setup.
      </Typography>

      {/* Card Grid */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: '1.5rem',
          textAlign: 'center',
        }}
      >
        {loading
          ? Array.from({ length: 6 }).map((_, idx) => (
            <Skeleton
              key={idx}
              variant="rectangular"
              height={160}
              sx={{ borderRadius: 3 }}
            />
          ))
          : cardStates.map((item) => (
            <MySettingCard
              key={item.title}
              {...item}
              showToggle
              onToggleClick={() => handleToggleClick(item)}
            />
          ))}
      </Box>

      {/* Toggle Confirmation Dialog */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="sm"
        aria-labelledby="confirm-toggle-dialog"
        PaperProps={{
          sx: {
            p: 2,
            borderRadius: "16px",
            border: "4px solid #00AAE7",
          }
        }}

      >
        {selectedCard && (
          <>
            <DialogTitle id="confirm-toggle-dialog" sx={{ padding: '0', }}>
              <Typography fontWeight={600} pb={1}>
                {selectedCard.status === 'enabled' ? 'Disable' : 'Enable'} "{selectedCard.title}"?
              </Typography>
            </DialogTitle>
            <DialogContent sx={{ padding: '0 0 15px 0', }}>
              <Typography variant="body2" sx={{ color: '#595959', fontSize: '14px', }}>
                Are you sure you want to{' '}
                {selectedCard.status === 'enabled' ? 'disable' : 'enable'} this feature?
              </Typography>
            </DialogContent>
            <DialogActions sx={{ paddingRight: '0', paddingLeft: '0' }}>
              <Button variant="contained" onClick={handleConfirmToggle} autoFocus sx={{ borderRadius: '5px', background: '#0B57D0', border: '1px solid #0B57D0' }}>
                OK
              </Button>
              <Button onClick={() => setOpenModal(false)} variant="outlined" sx={{ borderRadius: '5px', color: '#373737', background: '#DFDFDF', border: '1px solid #D9D9D9' }}>
                Cancel
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default EnableDisableFeatures;
